import { Component } from '@angular/core';
import { DataService } from './service/data.service';
import { DynamicFieldsManagerService } from './service/dynamic-fields-manager.service';


//declare var TRANSLATIONS: any;

export class BaseComponent {

    data: DataService;

    constructor(dataService: DataService) {
        this.data = dataService;
    }

    public translate(key: string): string {

        try {
            var k = key.replace("Translation.", "");
            var translations = this.data.translations?.Translations;

            if (typeof (translations) != "undefined" && translations) {
                if (translations[k]) {
                    return translations[k];
                } else {
                    return key;
                }
            }


            return key;
        } catch (e) {
            return key;
        }
    }

}
